module.exports = __webpack_public_path__ + "fonts/fa-solid-900.70e65a7.eot";